import { CheckCircle2 } from 'lucide-react';
import type { HackerCreditsAnthropic } from '@/types';
import { CreditsShell } from './components/CreditsShell';

// /hacker/credits/anthropic — the read-back of what the onboarding form sent to Anthropic.
// Which profile carries the answers is decided by the controller (the Next page searched
// every profile of the hacker for the first one with any Anthropic data).
export default function Anthropic({ profile }: HackerCreditsAnthropic) {
  return (
    <CreditsShell>
      <div className="space-y-6">
        <div className="border-2 border-primary bg-background/80 p-6 backdrop-blur-sm sm:p-8 md:p-10">
          <div className="space-y-6">
            <div className="border-primary/20 border-b pb-6">
              <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
                <div>
                  <h2 className="font-bold font-title text-2xl text-primary sm:text-3xl md:text-4xl">
                    <span className="bg-primary px-2 py-1 text-background">
                      ANTHROPIC
                    </span>{' '}
                    CREDITS
                  </h2>
                  <p className="mt-2 text-primary/70 text-sm">
                    Recibe $50 USD en créditos de API de Anthropic
                  </p>
                </div>
                <div
                  className="h-8 w-32"
                  style={{
                    backgroundColor: 'hsl(var(--primary))',
                    maskImage: 'url(/assets/logos/anthropic-crop.svg)',
                    maskSize: 'contain',
                    maskRepeat: 'no-repeat',
                    maskPosition: 'center',
                    WebkitMaskImage: 'url(/assets/logos/anthropic-crop.svg)',
                    WebkitMaskSize: 'contain',
                    WebkitMaskRepeat: 'no-repeat',
                    WebkitMaskPosition: 'center',
                  }}
                />
              </div>
            </div>

            <div className="space-y-6">
              {profile ? (
                <>
                  <div className="flex items-center gap-3 border-2 border-primary bg-primary/5 p-4">
                    <CheckCircle2 className="h-6 w-6 text-primary" />
                    <div>
                      <p className="font-bold font-title text-primary">
                        Petición enviada a Anthropic
                      </p>
                      <p className="font-mono text-primary/70 text-sm">
                        {profile.anthropicInfoSentAt
                          ? `Enviado el ${new Date(profile.anthropicInfoSentAt).toLocaleDateString('es-ES')}`
                          : 'Tu información ha sido registrada'}
                      </p>
                    </div>
                  </div>

                  <div className="space-y-4">
                    <h3 className="font-bold font-title text-primary text-xl uppercase">
                      Información enviada
                    </h3>

                    <div className="space-y-3">
                      {profile.anthropicAccountEmail && (
                        <div className="border-primary border-l-4 pl-4">
                          <p className="font-bold font-title text-primary/70 text-sm uppercase">
                            Email
                          </p>
                          <p className="font-mono text-primary">
                            {profile.anthropicAccountEmail}
                          </p>
                        </div>
                      )}

                      {profile.anthropicOrgId && (
                        <div className="border-primary border-l-4 pl-4">
                          <p className="font-bold font-title text-primary/70 text-sm uppercase">
                            Organization ID
                          </p>
                          <p className="break-all font-mono text-primary text-sm">
                            {profile.anthropicOrgId}
                          </p>
                        </div>
                      )}

                      {profile.anthropicUsedProducts &&
                        profile.anthropicUsedProducts.length > 0 && (
                          <div className="border-primary border-l-4 pl-4">
                            <p className="font-bold font-title text-primary/70 text-sm uppercase">
                              Productos usados
                            </p>
                            <ul className="mt-2 space-y-1">
                              {profile.anthropicUsedProducts.map((product) => (
                                <li
                                  key={product}
                                  className="font-mono text-primary text-sm"
                                >
                                  • {product}
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}

                      {profile.anthropicUpdates !== null && (
                        <div className="border-primary border-l-4 pl-4">
                          <p className="font-bold font-title text-primary/70 text-sm uppercase">
                            Actualizaciones de producto
                          </p>
                          <p className="font-mono text-primary">
                            {profile.anthropicUpdates ? 'Sí' : 'No'}
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </>
              ) : (
                <div className="border-2 border-primary/20 bg-background p-6 text-center">
                  <p className="font-bold font-title text-primary">
                    No has enviado tu información de Anthropic aún.
                  </p>
                  <p className="mt-2 font-mono text-primary/70 text-sm">
                    Esta información debería haberse completado durante el
                    onboarding.
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </CreditsShell>
  );
}
